var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.53 3.47a.75.75 0 0 1 0 1.06l-16 16a.75.75 0 0 1-1.06-1.06l16-16a.75.75 0 0 1 1.06 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.47 3.47a.75.75 0 0 0 0 1.06l16 16a.75.75 0 1 0 1.06-1.06l-16-16a.75.75 0 0 0-1.06 0",
  clipRule: "evenodd"
})));
export default SvgClose;